import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrash03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M8 3a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-1.064l-.642 9.625c-.05.756-.092 1.381-.167 1.89-.078.53-.201 1.014-.458 1.465a4 4 0 0 1-1.731 1.62c-.467.226-.959.317-1.493.36-.512.04-1.139.04-1.896.04h-3.098c-.757 0-1.384 0-1.896-.04-.534-.043-1.025-.134-1.493-.36a4 4 0 0 1-1.73-1.62c-.258-.451-.381-.935-.46-1.465-.074-.509-.115-1.134-.166-1.89L4.064 7H3a1 1 0 0 1-1-1Zm8 3.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Zm5 1a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgTrash03.displayName = 'Trash03';
export default SvgTrash03;
